import { CompanyLogo } from "@comparaonline/ui-offer-company-logo";
import React from "react";

import { useAppContext } from "../../../../../../../lib/appContext";
import { LOGO_HEIGHT, LOGO_WIDTH, LOGO_WIDTH_MOBILE, LOGO_HEIGHT_MOBILE } from "./constants";
import { Styles, withStyles } from "./styles";
import { LogoProps } from "../types";

const getImageSize = (isMobile: boolean) =>
  isMobile
    ? {
        height: LOGO_HEIGHT_MOBILE,
        width: LOGO_WIDTH_MOBILE
      }
    : {
        height: LOGO_HEIGHT,
        width: LOGO_WIDTH
      };

const BaseLogo: React.FC<LogoProps & Styles> = ({ alt, src, classes }) => {
  const { isMobile } = useAppContext();
  return (
    <CompanyLogo
      alt={alt}
      src={src}
      hasShadow={true}
      className={classes.logo}
      {...getImageSize(isMobile)}
    />
  );
};

export const Logo = withStyles(BaseLogo);
